import { Link } from "gatsby";
import React from "react";
import { Privacy } from "../svg/other";
import { Product_Routes } from "../../data/Routes";
export function QuePrivacy() {
  return (
    <div className="que-privacy">
      <div className="que-privacy-container">
        <div className="que-privacy-svg">
          <Privacy />
        </div>
        <div>
          <p>
            By Clicking Submit, you agree to the Digital Comparision
            <Link to={Product_Routes.TermandCondition}>Terms of Service</Link>
            and <Link to={Product_Routes.PrivacyPolicy}>Privacy Policy</Link>.
            Consent is not a condition of purchasing any products or services.
          </p>
        </div>
      </div>
    </div>
  );
}
